/**
 * 設計 Token 系統
 * 這個文件定義了應用程式的設計語言，包括顏色、排版、間距等基本元素
 */

// 從 JS 檔案導入原始 Token
// @ts-ignore 忽略無聲明文件的警告，因為我們已經有 tokens.d.ts
import tokens from "./tokens";

// 確保 tokens 有 transition 屬u6027
if (tokens.transitions && !tokens.transition) {
  tokens.transition = tokens.transitions;
}

// 導出 tokens
export { tokens };

// 導出 darkTokens (如果存在)
export const darkTokens = tokens.darkTokens
  ? {
      ...tokens.darkTokens,
      // 確保 darkTokens 也有 transition 屬u6027
      transition:
        tokens.darkTokens.transition ||
        tokens.darkTokens.transitions ||
        tokens.transition,
    }
  : undefined;
